import { serverErrors } from 'helpers/api_errors';

export function digitsIn(value: string): number {
  return value.replace(/\D/g, '').length;
}

// helpers/api throws the server's `errors` array, or the raw axios error when the response carried
// none - so a message is only available in the first case.
export function messageFor(thrown: unknown): string {
  const messages = serverErrors(thrown);
  if (messages.length > 0) {
    return String(messages[0]);
  }

  return 'Something went wrong. Try again in a moment.';
}
